import React, { ReactNode } from "react"
import { cva, VariantProps } from "class-variance-authority"

import { cn } from "@/domains/library"

const messageBoxVariants = cva("rounded-md border", {
  variants: {
    variant: {
      error: "border-error-border/25 bg-error-background/25 text-error-text",
      info: "border-p200-light bg-p300-light text-t300",
      scalest: "border-scalest-border/25 bg-scalest-background/25 text-scalest-text",
      success: "border-[#00B356]/25 bg-[#00B356]/10 text-[#00B356]",
    },
    size: {
      xxs: "max-h-[22px] gap-1 px-[4px] py-[1px] text-[10px]",
      xs: "gap-2 px-3 py-2",
      sm: "gap-2 px-2 py-2",
      md: "gap-2 px-3 py-2.5",
      lg: "gap-2 px-4 py-3.5",
    },
  },
  defaultVariants: {
    variant: "info",
    size: "sm",
  },
})

interface ShortMessageBoxProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof messageBoxVariants> {
  icon: ReactNode
  children: React.ReactNode
  className?: string
}

export const ShortMessageBox = ({
  icon,
  children,
  variant,
  size = "sm",
  className,
  ...props
}: ShortMessageBoxProps) => {
  return (
    <div {...props} className={cn("flex flex-row items-center", messageBoxVariants({ variant, size }), className)}>
      <div className="flex w-6 flex-shrink-0 items-center justify-center">{icon}</div>
      <div className="flex-1">{children}</div>
    </div>
  )
}
